// pb-wvdk-pick-mix.js — Weekend van de Klant (3–4 Oct 2026) notice in the
// Planet B Pick & Mix basket.
//
// Empty basket: "Bestel voor €25…" under the empty-state boxes. With items, in
// the footer: the same line while the bundle (plus whatever else is already in
// the cart) stays below the towel threshold, "Hoera!…" from it on. Visual
// only, like the cart drawer block.
//
// Inputs:
// - window.PBWvdk (assets/pb-wvdk-cart-upsell.js): window, threshold, subtotal.
// - The P&M root's data-pm-total-cents / data-pm-item-count / data-pm-in-cart
//   and its pb:pick-mix:render event (sections/pb-pick-mix-bundle-planetb.liquid).
// Markup: snippets/pb-wvdk-pick-mix.liquid. Docs: .cursor/references/weekend-van-de-klant.md
(function () {
  if (window.__pbWvdkPickMix) return;
  window.__pbWvdkPickMix = true;

  // Lines PBCart.replacePickMixBundle removes before adding the new bundle, so
  // they must not count twice (same filter as assets/pb-cart.js).
  function isPickMixLine(line) {
    const title = String(line?.merchandise?.product?.title || '').toLowerCase();
    if (title.includes('pick & mix')) return true;
    return (line?.attributes || []).some(
      (a) => (a.key === '_pick_mix' || a.key === 'pb_pick_mix') && a.value === 'true',
    );
  }

  let restOfCartCents = 0;

  async function refreshCart(detailCart) {
    let cart = detailCart && detailCart.lines ? detailCart : null;
    if (!cart && window.PBCart && typeof window.PBCart.current === 'function') {
      try {
        cart = await window.PBCart.current();
      } catch {
        cart = null;
      }
    }
    const shared = window.PBWvdk;
    if (!cart || !shared) return;
    const lines = (cart.lines?.edges || []).map((edge) => edge?.node).filter((line) => line && !isPickMixLine(line));
    restOfCartCents = shared.qualifyingSubtotal(lines);
  }

  // "€25" for a whole amount, as in the design; otherwise "€24,50".
  function thresholdLabel(shared) {
    const cents = shared.thresholdCents;
    return cents % 100 === 0 ? `€${cents / 100}` : shared.formatAmount(cents);
  }

  function setNotice(box, html) {
    const textEl = box.querySelector('[data-pb-wvdk-pm-text]');
    if (!textEl) return;
    if (textEl.innerHTML !== html) textEl.innerHTML = html;
    box.hidden = false;
  }

  function update(root) {
    const boxes = [...root.querySelectorAll('[data-pb-wvdk-pm]')];
    if (!boxes.length) return;

    const shared = window.PBWvdk;
    if (!shared || !shared.inWindow()) {
      boxes.forEach((box) => {
        box.hidden = true;
      });
      return;
    }

    const notReachedHtml = `Bestel voor <strong>${thresholdLabel(shared)}</strong> en krijg een <strong>gratis gastenhanddoekje</strong> 🎁`;
    const itemCount = Number(root.dataset.pmItemCount || 0);

    for (const box of boxes) {
      // Under the empty-state boxes: the section hides that wrapper itself
      // once the basket has items.
      if (box.dataset.pbWvdkPm === 'empty') {
        setNotice(box, notReachedHtml);
        continue;
      }

      if (itemCount === 0) {
        box.hidden = true;
        continue;
      }

      const bundleCents = Number(root.dataset.pmTotalCents || 0);
      const reached = restOfCartCents + bundleCents >= shared.thresholdCents;
      const inCart = root.dataset.pmInCart === 'true';

      if (!reached) {
        setNotice(box, notReachedHtml);
      } else if (inCart) {
        setNotice(
          box,
          '<strong>Hoera! Gratis</strong> handdoekje is binnen! <strong>Update nu je bundel</strong> en vind je cadeau in je cart 🎁',
        );
      } else {
        setNotice(
          box,
          '<strong>Hoera! Gratis</strong> handdoekje is binnen! <strong>Voeg je bundel toe</strong> en vind je gratis cadeau in je cart 🎁',
        );
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-pb-pick-mix]').forEach(update);
  }

  document.addEventListener('pb:pick-mix:render', (e) => {
    const root = e.target?.closest?.('[data-pb-pick-mix]');
    if (root) update(root);
  });
  document.addEventListener('pb:cart:updated', (e) => {
    refreshCart(e.detail?.cart).then(updateAll);
  });
  document.addEventListener('pb:wvdk:change', updateAll);

  // window.PBWvdk is set by another deferred script; both have run by
  // DOMContentLoaded.
  function init() {
    refreshCart().then(updateAll);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
